import { useRef, useState } from 'react';
import { Typography, Form, Divider, Card, Space, Layout } from 'antd';
import { Link } from 'react-router-dom';

import { IsRole } from '../../utils/helpers/helpers';
import BreadcrumbContainer from '../../containers/Breadcrumb';
import CustomButton from '../../components/CustomButton';
import INTERNAL_LINKS from '../../enums/InternalLinks';
import AdditionalDocumentsLegal from '../../pages/AdditionalDocumentsLegal/index';
import LegalPersonFormGeneralSection from './FormSections/general';
import LegalPersonFormSignatureSection from './FormSections/signature';

const { Title } = Typography;
const { Content } = Layout;
const breadcrumbItems = [
  {
    text: 'Proveedores y Consultores - Persona Jurídica',
    to: `${INTERNAL_LINKS.LEGAL_PERSONS}`,
  },
  {
    text: 'Registro de Persona Jurídica',
  },
];

const LegalPersonForm = ({
  person_id = 0,
  title = '',
  onFinish = () => {},
  setDocsComplete = () => {},
  initialValues = {},
  loading = false,
  readOnly = false,
  checkDocs,
}) => {
  const formRef = useRef(null);
  const [form] = Form.useForm();
  const [superUser] = useState(IsRole(6));

  return (
    <Content>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title className={'text-uppercase'} level={2}>
        {title}
      </Title>
      <Divider />
      <Form
        name="nest-messages"
        form={form}
        layout="vertical"
        onFinish={onFinish}
        scrollToFirstError
        onValuesChange={(data) => {
          if (data.hasOwnProperty('notificacion_pais')) {
            form.setFieldsValue({
              notificacion_estado: null,
              notificacion_ciudad: null,
            });
          }
          if (data.hasOwnProperty('notificacion_estado')) {
            form.setFieldsValue({ notificacion_ciudad: null });
          }
          if (data.hasOwnProperty('constituido_colombia')) {
            let toSet;
            if (
              data.constituido_colombia === initialValues.constituido_colombia
            ) {
              toSet = {
                numero_identificacion: initialValues.numero_identificacion,
                digito_verificacion: initialValues.digito_verificacion,
                nitConfirm: initialValues.numero_identificacion,
              };
            } else {
              toSet = {
                numero_identificacion: null,
                digito_verificacion: null,
                nitConfirm: null,
              };
            }
            form.setFieldsValue(toSet);
          }
        }}
        initialValues={{ ...initialValues }}
        autoComplete="off"
      >
        <LegalPersonFormGeneralSection
          initialValues={initialValues}
          readOnly={readOnly}
          divRef={formRef}
        />
        <LegalPersonFormSignatureSection readOnly={readOnly} />
        {!readOnly && (
          <Form.Item>
            <Space>
              <CustomButton
                loading={loading}
                text="Guardar Información general"
              />
              {superUser && (
                <CustomButton
                  type={'default'}
                  className={'back-button'}
                  htmlType="button"
                  text={<Link to={INTERNAL_LINKS.LEGAL_PERSONS}> Volver </Link>}
                />
              )}
            </Space>
          </Form.Item>
        )}
        {person_id > 0 && (
          <>
            <AdditionalDocumentsLegal
              person_id={person_id}
              readOnly={readOnly}
              setDocsComplete={setDocsComplete}
            />
            {!readOnly && (
              <Card size={'small'} bordered={false}>
                <Space>
                  <CustomButton
                    text="Guardar y terminar registro"
                    loading={loading}
                    onClick={async () => {
                      try {
                        await form.validateFields();
                        form.submit();
                        checkDocs();
                      } catch (e) {
                        formRef.current.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                    htmlType="button"
                  />
                  {superUser && (
                    <CustomButton
                      type={'default'}
                      className={'back-button'}
                      htmlType="button"
                      text={
                        <Link to={INTERNAL_LINKS.LEGAL_PERSONS}>Volver</Link>
                      }
                    />
                  )}
                </Space>
              </Card>
            )}
          </>
        )}
      </Form>
    </Content>
  );
};
export default LegalPersonForm;
